module.exports = __webpack_public_path__ + "static/media/postman.05396d84.jpg";